/* eslint-disable max-len */
import Vuex from 'vuex';
import Vue from 'vue';

import referenceStore from '@shared/store/reference.store';
import errorsStore from '@shared/store/errors.store';
import commonStore from '@shared/store/enterprise.common.store';
import repositoryFilesStore from '@shared/store/repository-files.store';

/* IMPORTED MODULES */
import issueStore from '@shared/modules/project-issue/store';
import mergeRequestStore from '@shared/modules/merge-request/store';
import requestApprovalStore from '@shared/modules/merge-request-approver/store';
import teamRequestApprovalStore from '@shared/modules/merge-request-approver/store/team';
import companyRequestApprovalStore from '@shared/modules/merge-request-approver/store/company';
import notificationStore from '@shared/modules/notifications/store';
import ciCdStore from '@shared/modules/ci-cd/store';
import filesTreeStore from '@shared/modules/project-files/store';
import commitStore from '@shared/modules/commit/store';
import customScriptsStore from '@shared/modules/custom-scripts/store';
import searchStore from '@shared/modules/search/store';
import vulnerabilityStore from '@/shared-modules/modules/security/store';
import sendChunks from '@/shared-modules/modules/registry/store';
import adminStore from '@/shared-modules/modules/admin/company/store';
import customRolesStore from '@/shared-modules/modules/custom-roles/store';
import projectSettingsStore from '@/shared-modules/modules/project-settings/store';
import projectCreateStore from '@/shared-modules/modules/project-create/store';
import adminProjectCreateStore from '@/shared-modules/modules/admin/admin-project-create/store';
import adminSettingsStore from '@/shared-modules/modules/admin/settings/store';
import entityMembersStore from '@/shared-modules/shared-components/wrappers/store';

Vue.use(Vuex);
/* IMPORTED MODULES */

export default new Vuex.Store({
  modules: {
    repositoryFilesStore,
    referenceStore,
    errorsStore,
    commonStore,

    /* IMPORTED MODULES */
    mergeRequestStore,
    issueStore,
    notificationStore,
    requestApprovalStore,
    teamRequestApprovalStore,
    companyRequestApprovalStore,
    ciCdStore,
    vulnerabilityStore,
    filesTreeStore,
    commitStore,
    sendChunks,
    customRolesStore,
    adminStore,
    projectCreateStore,
    projectSettingsStore,
    adminProjectCreateStore,
    adminSettingsStore,
    customScriptsStore,
    searchStore,
    entityMembersStore
    /* IMPORTED MODULES */
  }
});
